import Helpers from "../../commons/helpers";
import { IPagedList } from "../../commons/interfaces";
import { Constants } from "../../constants/constants";
import { IBaseRequestGetPaged, IPolicy, PolicyRequirement, RoleResourcePermission } from "./../../commons/interfaces";
import IdentityClient from "./IdentityClient";

export interface IRequestGetPagedPolicy extends IBaseRequestGetPaged {
    clientId?: string;
    serviceCode?: string;
    tenantCode?: string;
}

export interface IRequestUpdatePolicy {
    tenantCode: string;
    serviceCode: string;
    clientId: string;
    organizationId: string;
    policyName: string;
    description: string;
    resources: Pick<RoleResourcePermission, "resourceCode" | "permission" | "quota">[];
    requirements: Pick<PolicyRequirement, "name" | "compareType" | "type" | "values">[];
    id: string;
    updateTime: number | string;
}

export type IRequestCreatePolicy = Omit<IRequestUpdatePolicy, "id" | "updateTime">;

const PolicyService = {
    async getAll(data: { clientId?: string; tenantCode?: string; serviceCode?: string; searchText?: string }) {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(`${Constants.ApiPath.POLICY.GET_ALL}?${query}`);
        return result.data.result;
    },

    async getPaged(data: any): Promise<IPagedList<IPolicy>> {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(`${Constants.ApiPath.POLICY.GET_PAGED}?${query}`);
        return result.data.result;
    },

    async getDetail(id: string): Promise<IPolicy> {
        const result = await IdentityClient().get(Constants.ApiPath.POLICY.GET_DETAIL + `/${id}`);
        return result.data.result;
    },

    async create(data: IRequestCreatePolicy) {
        const result = await IdentityClient().post(Constants.ApiPath.POLICY.CREATE, data);
        return result.data.result;
    },

    async update(data: IRequestUpdatePolicy) {
        const result = await IdentityClient().post(Constants.ApiPath.POLICY.UPDATE, data);
        return result.data;
    },

    async delete(data: { id: string }) {
        const result = await IdentityClient().delete(Constants.ApiPath.POLICY.DELETE + `/${data?.id}`, { data });
        return result.data;
    },
};

export default PolicyService;
